import * as React from 'react';
import {useState} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {InputLabel, MenuItem, Select, TextField} from "@mui/material";
import * as CommunicationService from "../../../services/CommunicationService";
import * as LogicService from "../../../services/LogicService";
import * as AlertMapper from "../../../services/AlertMapper";
import {changeStatusForOrder} from "../../../services/CommunicationService";
import {STATUSES} from "../../../services/LogicService";

export default function OrderStatusModal({row, open, handleClose}) {

    const [orderStatus, setOrderStatus] = React.useState(row.status);

    const handleSend = () => {
        CommunicationService.changeStatusForOrder(row.id, orderStatus)
            .then((response) => {
                LogicService.setAlertMessageAndSeverity(AlertMapper.KNOWN_SUCCESSES.ALERT_SENT);
                row.status = orderStatus;
                handleClose();
            })
            .catch((error) => {
                LogicService.setAlertMessageAndSeverity(AlertMapper.getErrorMessage(error));
            });
    }

    const changeOrderStatus = (event) => {
        const {
            target: {value},
        } = event;
        setOrderStatus(value);
    }

    return (
        <Dialog
            BackdropProps={{style: {backgroundColor: 'rgb(255, 255, 255)', opacity: 0.3}}}
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {"Schimbare status pentru Order #" + row.id}
            </DialogTitle>
            <DialogContent>
                <InputLabel id="alert-doc"
                            sx={{marginTop: "30px", marginBottom: "10px"}}>Status</InputLabel>
                <Select
                    labelId="alert-doc"
                    value={orderStatus}
                    label="Status"
                    onChange={changeOrderStatus}
                    sx={{marginBottom: "30px", minWidth: "500px"}}
                >
                    {
                        Object.keys(STATUSES).map(status => <MenuItem
                            key={status}
                            value={status}
                        >
                            {status}
                        </MenuItem>)
                    }
                </Select>

            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color={"error"} autoFocus>
                    Close
                </Button>
                <Button onClick={handleSend} disabled={orderStatus == null}>
                    Change status
                </Button>
            </DialogActions>
        </Dialog>

    );
}
